import type { IPartnership } from '../partnership';
import type { IPartnershipsModel } from './model';

export default (self: IPartnershipsModel) => ({
  get filteredList() {
    return self.filteredModels.map((partnership: IPartnership) => ({
      id: partnership.id,
      created_at: partnership.created_at,
      partnerId: partnership.partnerId,
      partnerName: partnership.partnerName,
      partnerExternalId: partnership.partnerExternalId,
      organizationId: partnership.organizationId,
      organizationName: partnership.organizationName,
      partnerAddress: partnership.partnerAddress,
      organizationExternalId: partnership.organizationExternalId
    }));
  },
  get partnersValueLabelPais() {
    return self.toArray
      .map((partnership: IPartnership) => partnership.partnerValueLabelPair)
      .sort(({ label: label1 }, { label: label2 }) => label1.localeCompare(label2));
  }
});
